<template>
    <div >
      <div class="loader-wrapper"  v-show="this.isLoading">
        <div class="loader">Loading...</div>
      </div>
      <RegistrationForm :cpParams="cpParams" :submitFn="submitCP"/>
    </div>
  </template>
  <script>
  import RegistrationForm from "../components/RegistrationForm.vue";
  
  export default {
    name: 'App',
    components: {
      RegistrationForm
    },
    data () {
    return {
      isLoading: false,
      cpParams: {
        name: null,
        contact_number: null,
        email: null,
        number_of_attendees: null,
        firm_name: null,
        rera_no: null,
        location: null,
        event_name: "BalajiSkyline Kharghar"
      },
    }
  },
  methods: {
    submitCP() {
      this.isLoading = true
      this.cpParams.number_of_attendees = this.cpParams.number_of_attendees ? String(this.cpParams.number_of_attendees) : null
      this.cpParams.contact_number = this.cpParams.contact_number ? String(this.cpParams.contact_number) : null
      this.$axios.post(`cp_app/brokers`, {broker: this.cpParams})
        .then(res => {
          this.$swal({
            title: "CP Registered Successfully!",
            icon: "success",
          }).then(
            this.isLoading = false,
            this.cpParams = {
              name: null,
              contact_number: null,
              email: null,
              number_of_attendees: null,
              firm_name: null,
              rera_no: null,
              location: null,
              event_name: "BalajiSkyline Kharghar"
            },
          );
        })
        .catch(err => {
          this.isLoading = false
          if (err.response.status === 500) {
            this.$swal({
              title: "Server Error!",
              icon: "error",
            });
          } else {
            this.isLoading = false
            this.$swal({
              title: "Error",
              text: err.response.data.message,
              icon: "error",
            });
          }
        })
      },
    }
  }
  </script>
  
  <style>
  </style>
  